var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('footer',[_vm._v("©"+_vm._s(_vm.logo_name)+" Technology. All Rights Reserved.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }